import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const Modal = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 32px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const Title = styled.h2`
  color: #333;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
`;

export const Message = styled.p`
  color: #666;
  font-size: 16px;
  margin-bottom: 16px;
  text-align: center;
`;

export const Question = styled.p`
  color: #333;
  font-size: 16px;
  margin-bottom: 24px;
  text-align: center;
  font-weight: 500;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;

  button {
    flex: 1;
    min-width: 150px;
  }
`;

export const CancelButton = styled.button`
  flex: 1;
  min-width: 150px;
  padding: 12px 24px;
  border: 2px solid #ccc;
  background-color: white;
  color: #666;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #999;
    color: #333;
    background-color: #f5f5f5;
  }
`;
